// extracted by mini-css-extract-plugin
module.exports = {"root":"IssuuCatalogBlock_root__lPlR7"};